import { createAsyncThunk } from '@reduxjs/toolkit';
import notify from '../../utils/notify';

//Include Both Helper File with needed methods
import {
  getTeamData as getTeamDataApi,
  addTeamData as addTeamDataApi,
  updateTeamData as updateTeamDataApi,
  deleteTeamData as deleteTeamDataApi,
} from '../../helpers/fakebackend_helper';

export const getTeamData = createAsyncThunk('team/getTeamData', async () => {
  try {
    const response = getTeamDataApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const addTeamData = createAsyncThunk('team/addTeamData', async team => {
  try {
    const response = addTeamDataApi(team);
    notify.success('Team Data added successfully.');
    return response;
  } catch (error) {
    notify.apiError(error, 'add team data');
    return error;
  }
});

export const updateTeamData = createAsyncThunk(
  'team/updateTeamData',
  async project => {
    try {
      const response = updateTeamDataApi(project);
      notify.success('Team Data updated successfully.');
      return response;
    } catch (error) {
      notify.apiError(error, 'update team data');
      return error;
    }
  }
);

export const deleteTeamData = createAsyncThunk(
  'team/deleteTeamData',
  async project => {
    try {
      const response = deleteTeamDataApi(project);
      notify.success('Team Data deleted successfully.');
      return response;
    } catch (error) {
      notify.apiError(error, 'delete team data');
      return error;
    }
  }
);
